import { Typography } from '@material-ui/core'
import { Fragment } from 'react'

const ResolutionContenu = ({ record }) => (
  <Fragment>
    <Typography
      dangerouslySetInnerHTML={{ __html: record.contenu_bo }}
      style={{ textAlign: 'justify' }}
      variant="body2"
    ></Typography>
  </Fragment>
)
export default ResolutionContenu
